var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCordinator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 117.438,
    viewBox: "0 0 232 117.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38326",
    "data-name": "Group 38326",
    transform: "translate(-826 -430.563)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7113",
    "data-name": "Rectangle 7113",
    width: 232,
    height: 117,
    rx: 5,
    transform: "translate(826 431)",
    fill: "#191bc3",
    opacity: 0.781
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37381",
    "data-name": "Group 37381",
    transform: "translate(996.504 430.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65014",
    "data-name": "Path 65014",
    d: "M2960.331,90.562s-24.779,6.1-37.445,18.324c-3.893,3.754-6.566,8.175-6.763,13.531-.17,4.475,1.873,9.818,7.208,15.7,6.444,7.1,14.2,31.109,14.726,38.663C2939.8,201.5,2899.428,208,2899.428,208h60.866V90.562Z",
    transform: "translate(-2899.504 -90.562)",
    fill: "#ef8a79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65016",
    "data-name": "Path 65016",
    d: "M2960.331,90.562s-24.779,6.1-37.445,18.324c-3.893,3.754-6.566,8.175-6.763,13.531-.17,4.475,1.873,9.818,7.208,15.7,6.444,7.1,14.2,31.109,14.726,38.663C2939.8,201.5,2899.428,208,2899.428,208h60.866V90.562Z",
    transform: "translate(-2909.504 -90.562)",
    fill: "#ef8a79",
    opacity: 0.28
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCordinator);
export default __webpack_public_path__ + "static/media/Cordinator.1ff63de003537293f98df978348b3486.svg";
export { ForwardRef as ReactComponent };